// extracted by mini-css-extract-plugin
export var panelHeader = "styles-module__panelHeader___IEMxF";
export var panelTitle = "styles-module__panelTitle___xKd1R";
export var panelSubtext = "styles-module__panelSubtext___wt8qu";